import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

interface IProps {
  params?: {
    category?: string;
    accessType?: string;
    difficulty?: string;
  };
  enabled?: boolean;
}

/** The catalog's subject cards, narrowed by the same filters as the test list (never by a subject). */
export const usePublicSubjects = ({ params, enabled = true }: IProps = {}) => {
  return useQuery({
    queryKey: ['public-test-subjects', params ?? {}],
    enabled,
    queryFn: async () => (await Api.PublicSubjects(params)).data,
    retry: false,
  });
};

export default usePublicSubjects;
